module.exports = __webpack_public_path__ + "common/sidebar/img-card-list-0ef3e11fbfa12d464da313e387ca265a.png";